import React from "react";
import { Grid, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useDispatch } from "react-redux";
import { AccountCircle } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import StorageUtil from "../../../utils/storageUtil";
import { styles } from "../../../styles";
import clsx from "clsx";
import CreateIcon from "../Icon/Icon";
import ViewUtility, { Icons } from "../../../utils/viewUtility";
import AuthService from "../../../utils/authService";
import { useHistory, useLocation } from "react-router-dom";
import routes from "../../../utils/routes";
import { LOG_OUT } from "../../../modules/auth/actionTypes";
const useStyles = makeStyles(styles);

const UserProfile = () => {
  const userInfo = AuthService.getUserData();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { firstName = "", lastName = "" } = userInfo || {};
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    StorageUtil.removeAll();
    dispatch({ type: LOG_OUT });
    setAnchorEl(null);
    history.push(routes.LOGIN);
  };

  const handleProfile = () => {
    history.push(routes.PROFILE, location );
    setAnchorEl(null);
  };

  return <>
    <Grid item className={classes.root}>
      <Grid container alignItems="center">
        <Grid item className={classes.padding10}>
          <Typography
            variant="caption"
            className={clsx(classes.blackColor, classes.textUpperCase)}>{`${firstName} ${lastName}`}</Typography>
        </Grid>
        <Grid item className={classes.userInfoIcon}>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
            size="large">
            <AccountCircle className={classes.accountIcon} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            className={classes.menuWrap}
            PaperProps={{ style: { paddingBottom: "0" } }}
            id="menu-appbar"
            open={open}
            onClose={handleClose}>
            <MenuItem onClick={handleProfile}>
              <AccountCircleIcon className={classes.profileIcon} />
              <Typography className={clsx(classes.paddingLeft8, classes.color4a4a4a)}>{ViewUtility.PROFILE}</Typography>
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <CreateIcon iconType={Icons.IC_LOG_OUT} className={classes.logOutIcon} />{" "}
              <Typography className={clsx(classes.paddingLeft8, classes.color4a4a4a)}>{ViewUtility.LOG_OUT}</Typography>{" "}
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    </Grid>
  </>;
};
export default UserProfile;
